/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useCallback } from "react";
import { useFloodgateFeature } from "hooks/useFloodgateFeature";

type SkuKeys = { podcast_premium: string; firefly_pro: string };
type SkuT = (keys: SkuKeys, opts?: Record<string, unknown>) => string;

// I18n facade that picks between two translation keys based on the
// podcast_sku_migration_enabled Floodgate flag. The flag is queried directly
// from the frontend FloodgateClient so unauthenticated users honor it too.
// Pass the existing "Podcast Premium" key and the new "Firefly Pro" variant.
export const useSkuMigrationI18n = (): SkuT => {
  const enabled = useFloodgateFeature("podcast_sku_migration_enabled");
  return useCallback<SkuT>(
    (keys, opts = {}) =>
      I18n.t(enabled ? keys.firefly_pro : keys.podcast_premium, opts),
    [enabled]
  );
};
